import { connect } from 'react-redux';
import * as selector from '../CBILSSelector';
import MainContentPending from '../../pageStructure/mainContentPending/index';
import OutstandingLoanView from './outstandingLoanView/OutstandingLoanView';
import ApplyFlexiLoanInfoView from '../../applyFlexiLoanView/ApplyFlexiLoanInfoView/ApplyFlexiLoanInfoView';
import { RootState } from '@iwProvider/configureStore';

const mapStateToProps = (state: RootState) => ({
    ready: state.CBILSDashboard.ready,
    hasOutstandingBalance:
        selector.getSecondCBILSAccountOutstandingTotal(state)! > 0
});

type PropsFromRedux = ReturnType<typeof mapStateToProps>;

const SecondCBILSDashboard = ({
    hasOutstandingBalance,
    ready
}: PropsFromRedux) => {
    if (!ready) {
        return <MainContentPending />;
    }

    if (hasOutstandingBalance) {
        return <OutstandingLoanView />;
    }

    return <ApplyFlexiLoanInfoView />;
};

// eslint-disable-next-line import/no-default-export
export default connect(mapStateToProps)(SecondCBILSDashboard);
